module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_GA-ebec6d54d8ca468ff48ee9e9dd597c30.svg";